module.exports = ".twitter {\n  height: 400px;\n  overflow-y: auto; }\n"